import type { RunFilter } from '@console/types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createSavedView, deleteSavedView, fetchSavedViews } from './api.js'

const savedViewsQueryKey = ['saved-views'] as const

export function useSavedViews() {
  return useQuery({
    queryKey: savedViewsQueryKey,
    queryFn: fetchSavedViews,
  })
}

export function useCreateSavedView() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ name, filter }: { name: string; filter: RunFilter }) =>
      createSavedView(name, filter),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: savedViewsQueryKey })
    },
  })
}

export function useDeleteSavedView() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteSavedView(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: savedViewsQueryKey })
    },
  })
}
